import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button } from '@/ui_v3';

/**
 * 폴더를 불러오지 못했을 때의 전면 안내. 폴더 상세와 폴더 수정이 목적지만 다르게 쓴다.
 *
 * `replace` 로 보낸다 — 뒤로 가기로 다시 오류 화면에 오지 않게.
 */
export const FolderErrorFallback = ({
  actionHref
}: {
  actionHref: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const router = useRouter();
  return <div className={'flex min-h-dvh flex-col items-center justify-center gap-md'} data-sentry-component="FolderErrorFallback" data-sentry-source-file="FolderErrorFallback.tsx">
      <p className={'text-body-lg-bold text-default'}>
        {t('common:folder.detail.error.title')}
      </p>
      <Button variant={'outlined'} intent={'neutral'} size={'md'} onClick={() => void router.replace(actionHref)} data-sentry-element="Button" data-sentry-source-file="FolderErrorFallback.tsx">
        {t('common:folder.detail.error.action')}
      </Button>
    </div>;
};